<template>
  <div class="container">
    <div style="margin-bottom: 1rem">
      <el-row>
        <content-title :nav="nav"></content-title>
      </el-row>
      <el-descriptions title="场馆详情">
        <el-descriptions-item label="场馆名称">
          {{ orgInfo.name }}
        </el-descriptions-item>
      
      </el-descriptions>
    </div>

    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="场地" name="device">
        <promt ref="device"></promt>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
<script>
import promt from "../components/club/promt.vue";


export default {
  components: {
    promt,
  },
  data() {
    return {
      id: "",
      nav: { firstNav: "汇合空间", secondNav: "场馆详情" },
      orgInfo: {},
      activeName: "device",
    };
  },
  methods: {
    tabClick(v) {
      this.$refs[v.name].init();
    },
    getOrgDetails() {
      let url = "/shared/club/findById";
      this.$get(url, {
            id: this.id,
          })
        .then((res) => {
          this.orgInfo = res.data.data;
        });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getOrgDetails();
   this.$refs[this.activeName].init();
  },
};
</script>
  
<style></style>
  